import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { batch } from "@preact/signals-react"
import { AppMarketsAutocomplete } from "@components/Autocomplete"
import { AppOfficesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { FlagsIconSeeker } from "@ui-seeker/core"
import { translateCountryName } from "@ui-seeker/utils"
import { autoEuropeProviderNormalizationDrawerData } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

const COUNTRY_ALIASES = { 'uk': 'gb' }

const filterCountryOptions = (options, { inputValue }) => {
	const input = inputValue.toLowerCase()
	const alias = COUNTRY_ALIASES[input]
	return options
		.filter(({ label }) => {
			const code = label?.toLowerCase()
			const name = translateCountryName(label)?.toLowerCase()
			return code?.includes(input) || name?.includes(input) || (alias && code?.includes(alias))
		})
		.sort((a, b) => translateCountryName(a.label)?.localeCompare(translateCountryName(b.label)))
}

const formatCountryLabel = ({ value, label }) => (
	<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		<Typography>{translateCountryName(label)}</Typography>
		<FlagsIconSeeker countryName={value} />
	</Box>
)

export default function AutoEuropeProviderNormalizationFilterModeField() {
	const data = autoEuropeProviderNormalizationDrawerData.value
	// unchecked (default) → officeCountry | checked → office
	const isOfficeMode = data.filterMode === 'office'

	const handleModeToggle = () => {
		batch(() => {
			autoEuropeProviderNormalizationDrawerData.value = {
				...autoEuropeProviderNormalizationDrawerData.value,
				filterMode: isOfficeMode ? 'officeCountry' : 'office',
				officeCountries: [],
				offices: [],
			}
		})
	}

	const handleOfficeCountriesChange = (val) => {
		autoEuropeProviderNormalizationDrawerData.value = {
			...autoEuropeProviderNormalizationDrawerData.value,
			officeCountries: val ?? [],
		}
	}

	const handleOfficesChange = (val) => {
		autoEuropeProviderNormalizationDrawerData.value = {
			...autoEuropeProviderNormalizationDrawerData.value,
			offices: val ?? [],
		}
	}

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<Switch checked={isOfficeMode} onChange={handleModeToggle} size="small"/>
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					{isOfficeMode ? 'Filter by specific offices' : 'Filter by office countries'}
				</Typography>
			</Box>

			{isOfficeMode
				? <AppOfficesAutocomplete
					multiple
					urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/offices`}
					value={(data.offices ?? []).map(o => o?.value ?? o)}
					onChange={e => handleOfficesChange(e.target.value)}
				/>
				: <AppMarketsAutocomplete
					urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/office-countries`}
					label="Office countries"
					placeholder="All countries"
					multiple
					filterOptions={filterCountryOptions}
					formatOptionLabel={formatCountryLabel}
					value={data.officeCountries ?? []}
					onChange={e => handleOfficeCountriesChange(e.target.value)}
				/>
			}
		</Box>
	)
}